export default __webpack_public_path__ + "static/media/jpeg2.2cc82f99.jpg";